import { gbMessages } from "./en-GB";
import { itMessages } from "./it-IT";

export const getMessagesByLocale = (locale) => {
  switch (locale) {
    case "en":
      return gbMessages;

    case "it":
      return itMessages;

    default:
      return gbMessages;
  }
};
